const aboutList = [
    {
        shortTitle: "Conference Coverage Service Equips Clients with:",
        title: "Competitive Enablement for Targeting Successful Business Strategies",
        imageSrc: "img/researchCoverage/image-1.png",
        altText: "Healthcare Congress Business Strategies",
        iconImageSrc1: "img/researchCoverage/image-2.png",
        iconAltText1: "Healthcare Congress Business Strategies",
        iconImageSrc2: "img/icons-right.png",
        iconAltText2: "Healthcare Congress Business Strategies",
        link: "javascript:void(0);",
        btnTitle: "Request for Proposal",
        points: [
            {
                itemPoint: "Create a life cycle plan for your assets and company keeping in mind market dynamics.",
            },
            {
                itemPoint: "Develop effective future road mapping strategies and plan for long-term return on investment.",
            },
            {
                itemPoint: "Cultivate resilience from new development.",
            },
            {
                itemPoint: "Strengthen plans for R&D innovativeness with an understanding of the latest clinical data.",
            },
            {
                itemPoint: "Keep ahead in the evolving landscape by creating goal-managing strategies.",
            },
        ],
        listTitle: "Leverage our Insights to:",
        listPoints: [
            {
                itemPoint: "Assessing the evolving competitive landscape",
            },
            {
                itemPoint: "Shift in Perceptions of key thought leaders",
            },
            {
                itemPoint: "Updates on significant clinical studies",
            },
            {
                itemPoint: "Brand positioning strategies of competitors",
            },
            {
                itemPoint: "Awareness of new R&D Innovations",
            },
        ]
    },
];
const serviceList = [
    {
        title: 'Invest in your success',
        shortTitle: 'We are your one-stop solution provider for gaining timely conference coverage insights',
        description: 'With constant and continuous coverage of major conferences across therapy areas, DelveInsight is perfectly positioned to effectively map KITs and KIQs of client partners to develop an understanding of clinical outcomes and keep track of innovation and new initiatives.',
        link: '/request-for-proposal',
        btnTitle: 'Request proposal now',
        listPoints: [
            {
                id: 1,
                title: 'AACR',
                bgImageSrc: 'img/researchCoverage/dot-pattern.png',
                imageSrc: 'img/researchCoverage/aacr.png',
                altText: '',
                description: 'The AACR, one of the first and largest organizations dedicated to cancer research, organizes yearly meetings to discuss the most recent advancements in the field.',
                link: '/blog/tag/aacr-2022',
                btnTitle: 'Go to Coverage',
            },
            {
                id: 2,
                title: 'ASH',
                bgImageSrc: 'img/researchCoverage/dot-pattern.png',
                imageSrc: 'img/researchCoverage/Ash.png',
                altText: '',
                description: 'ASH Annual Meeting & Exposition is a leading forum for presenting and discussing the latest advances and research in hematology.',
                link: '/blog/tag/ash',
                btnTitle: 'Go to Coverage',
            },
            {
                id: 3,
                title: 'ASCO',
                bgImageSrc: 'img/researchCoverage/dot-pattern.png',
                imageSrc: 'img/researchCoverage/asco.png',
                altText: '',
                description: 'A leading international event for oncologists and researchers focused on presenting and discussing the latest advances, research, and developments in cancer care and treatment.',
                link: '/asco-conference-2024',
                btnTitle: 'Go to Coverage',
            },
            {
                id: 4,
                title: 'ATS',
                bgImageSrc: 'img/researchCoverage/dot-pattern.png',
                imageSrc: 'img/researchCoverage/ATS.png',
                altText: '',
                description: 'A major conference for the respiratory therapy area, dedicated to presenting and discussing the latest advances and research in pulmonology, critical care, and sleep medicine.',
                link: '/ats-conference/ats-2024',
                btnTitle: 'Go to Coverage',
            },
            {
                id: 5,
                title: 'ESMO',
                bgImageSrc: 'img/researchCoverage/dot-pattern.png',
                imageSrc: 'img/researchCoverage/esmo.png',
                altText: '',
                description: 'A major international oncology event that brings together medical professionals, researchers, and experts to present, discuss and exchange cutting-edge information and developments in cancer care and research.',
                link: '/esmo-conference-2024',
                btnTitle: 'Go to Coverage',
            },
            {
                id: 6,
                title: 'EULAR',
                bgImageSrc: 'img/researchCoverage/dot-pattern.png',
                imageSrc: 'img/researchCoverage/eular.png',
                altText: '',
                description: 'A congress for rheumatology professionals focused on promoting the exchange of scientific and medical knowledge and advancing the care of individuals affected by rheumatic and musculoskeletal diseases.',
                link: '/eular-conference/eular-2024',
                btnTitle: 'Go to Coverage',
            },
        ],
    },
    // Add more conference data objects here
];
const detailedProcessList =  [
    {
        title: 'Congress Preparation',
        imageSrc: 'img/researchCoverage/congress-preparation.png',
        items:[
            {
                title: 'Prepare Conference Planner',
                description: <>
                    <p>DelveInsight’s proprietary conference coverage methodology helps clients understand their coverage priorities by considering the most relevant aspects to cover.</p>
                    <p>By reviewing areas of interest and Key Intelligence Topics, a planner is prepared for each day</p>
                </>
            },
            {
                title: 'Prioritization and Selection of Abstracts Based on the Area of Interest',
                description: <>
                    <p>From the exhaustive list of conference topics, abstracts, sessions, and symposia, DelveInsight creates a priority list of coverage topics</p>
                    <p>The planner is prepared and shared with the client partners to keep them abreast of the process every step of the way</p>
                    
                </>
            },
            {
                title: 'Categorization Based on the Priority',
                description: <>
                    <p>The planner outlines the coverage, which is segmented into poster presentations, oral presentations, sessions, and symposia</p>
                    <p>Within these segments, the priority of each abstract is mentioned for conference coverage and analysis.</p>
                    
                </>
            },
            {
                title: 'Prepare and Review Of KIQs And Key Data Points',
                description:<>
                    <p>DelveInsight’s detailed plan is a thorough schedule of focused presentations that covers each Key Intelligence Topic of our client partners.</p>
                    <p>DelveInsight’s team of highly qualified analysts and subject matter experts attend the conference and accurately record each session</p>
                    
                </>
            },
        ],
    },
    {
        title: 'Data Gathering',
        imageSrc: 'img/researchCoverage/data-gathering.png',
        items:[
            {
                title: 'Capturing Intelligence',
                description:<>
                    <p>The team of analysts covers each session and presentation as per the schedule of the planner and captures insight</p>
                    <p>Capturing significant information by taking images of slides and posters</p>
                    <p>Tracking of relevant Social Media to track trends and gain instant insights into priority targets</p>
                </>
            },
            {
                title: 'Covering Sessions',
                description:<>
                    <p>The insight capturing will be through attending important talks, corporate symposiums, oral presentations, plenary discussions, late-breaking sessions, and poster presentations</p>
                    <p>The team will also attend priority corporate events and keynote sessions of interest</p>
                </>
            },
            {
                title: 'Interviewing Key Stakeholders and KOLs',
                description:<>
                    <p>Interview key opinion leaders, experts, and thought leaders to evaluate audience responses to ground-breaking data.</p>
                    <p>Interview MDs, business associates, and other influential figures to gain more information</p>
                </>
            },
            {
                title: 'Collecting Conference Materials to Understand the Product',
                description:<>
                    <p>Gathering resources that disclose product positioning and key messaging motifs to comprehend competitive strategies better.</p>
                    <p>Collating data from all the resources to be analysis ready for post-conference reporting</p>
                </>
            },
        ],
    },
    {
        title: 'Analysis and Reporting',
        imageSrc: 'img/researchCoverage/analysis-&-reporting.png',
        items:[
            {
                title: 'Organize Information From Key Sessions, Abstracts, and Posters',
                description:<>
                    <p>Creating a data repository of all information collated from the conference coverage</p>
                    
                    <p>Segregating insights in different segments to create an intelligent flow of information</p>
                    
                </>
            },
            {
                title: 'Addressing The Key Intelligence Questions',
                description:<>
                    <p>Analysis of insights to prepare an executive summary and detailed report</p>
                    <p>Delivering insights in client-requested format, highlighting insights and key takeaways, including recent breakthroughs, near-future plans, and upcoming milestones</p>
                    
                </>
            },
        ],
    },
];
const advantageList = {
    cards:[
        {
            title: 'Healthcare Conference Detailed Coverage',
            shortDescription: 'An extensive assessment of key intelligence topics',
            imageSrc: 'img/researchCoverage/healthcare-conference-detailed-coverage-01.svg',
            altText: 'Detailed Coverage',
        },
        {
            title: 'Gather Relevant Insights',
            shortDescription: 'A deep understanding of clinical research updates',
            imageSrc: 'img/researchCoverage/gather-relevant-insights-01.svg',
            altText: 'Detailed Coverage',
        },
        {
            title: 'Develop Strategies',
            shortDescription: 'Create opportunities and future road maps',
            imageSrc: 'img/researchCoverage/develop-strategies-01.svg',
            altText: 'Detailed Coverage',
        },
        {
            title: 'Intelligent De-brief Reports',
            shortDescription: 'Accurate analysis via deep expertise and experience',
            imageSrc: 'img/researchCoverage/intelligent-de-brief-reports-01.svg',
            altText: 'Detailed Coverage',
        },
    ],
   
    listPoints: [
        {
            itemPoint: 'Detailed planner with activities mapped out to keep clients updated on daily tasking',
        },
        {
            itemPoint: 'Creation of effective deliverables that provide keen insights',
        },
        {
            itemPoint: 'Analysis of information to develop insights through a dedicated team of subject matter experts',
        },
        {
            itemPoint: 'Leveraging DelveInsight’s years of experience in business consulting and competitive intelligence to provide accurate assessments of key developmental milestones',
        },
        {
            itemPoint: 'Multiple layers of analysis and iterative validation methodology to create effective strategies for the client’s future goals',
        },
        {
            itemPoint: 'Gain insights on recent developments in a time-sensitive manner to gain a competitive advantage in the ever changing healthcare landscape',
        },
    ],
};
const journeyList = [
    {
        title: 'Discuss key parameters',
        imageSrc: 'img/researchCoverage/Discuss-key-parameters-01.svg',
        iconImageSrc: 'img/researchCoverage/process-arrow.png',
        altText: 'Discuss key parameters'
    },
    {
        title: 'Keep Track of Progress',
        imageSrc: 'img/researchCoverage/Keep-track-of-progress-01.svg',
        iconImageSrc: 'img/researchCoverage/process-arrow.png',
        altText: 'Keep Track of Progress'
    },
    {
        title: 'Decode Outcomes',
        imageSrc: 'img/researchCoverage/Decode-outcomes-01.svg',
        iconImageSrc: 'img/researchCoverage/process-arrow.png',
        altText: 'Decode Outcomes'
    },
    {
        title: 'Gain a Competitive Advantage',
        imageSrc: 'img/researchCoverage/Gain-a-Competitive-advantage-01.svg',
        iconImageSrc: 'img/researchCoverage/process-arrow.png',
        altText: 'Gain a Competitive Advantage'
    },
];
const PastEventList = [
    {
        title: 'ASCO 2022 Conference intelligence around HER2 negative breast cancer assets',
        imageSrc: 'img/researchCoverage/Competitive-Intelligence.png',
        altText: 'ASCO 2022 Conference intelligence around HER2 negative breast cancer assets',
        link: '/case-study/conference-intelligence-product-assessment',
    },
    {
        title: 'Conference coverage in various oncology conferences',
        imageSrc: 'img/researchCoverage/Epidemiology-Assessment.png',
        altText: 'Conference coverage in various oncology conferences',
        link: '/case-study/oncology-assets',
    },
    {
        title: 'Conference coverage intelligence of asthma and COPD assets across the respiratory therapy area',
        imageSrc: 'img/researchCoverage/image-3.png',
        altText: 'Conference coverage intelligence of asthma and COPD assets across the respiratory therapy are',
        link: '/case-study/asthma-and-copd-assets',
    },
    {
        title: 'CAR-TCR summit coverage to track novel CAR-T cell therapies for B-cell malignancies',
        imageSrc: 'img/researchCoverage/image-4.png',
        altText: 'CAR-TCR summit coverage to track novel CAR-T cell therapies for B-cell malignancies',
        link: '/case-study/conference-coverage-car-tcr-summit',
    },
]



export {
    aboutList,
    serviceList,
    detailedProcessList,
    advantageList,
    journeyList,
    PastEventList,
}